
import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Courses from './components/Courses';
import LessonExamples from './components/LessonExamples';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from '../../components/feature/Footer';
import FAQ from './components/FAQ';
import About from './components/About';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Features />
        <About />
        <Courses />
        <LessonExamples />
        <Pricing />
        <Testimonials />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
